export default "__VITE_ASSET__653e7954__"